import './styles.scoped.css'
import {Navigate} from 'react-router-dom'
import {useAuth} from '../../contexts/AuthContext'
import {useGlobalStates} from '../../contexts/GlobalStatesContext'
import {useLocation} from 'react-router-dom'

export default ({children, routePermissions}) => {
    const {isAuthenticated, accountLoading, account, roles, permissions} = useAuth()
    const {messageBox, setMessageBox} = useGlobalStates()
    const location = useLocation()

    if (accountLoading || !routePermissions || !account || !roles || !permissions) {
        return null
    }

    if (isAuthenticated) {
        if (account?.show_welcome) {
            if (location.pathname !== '/welcome') {
                return <Navigate to="/welcome" replace />
            } else {
                return children
            }
        } else if (roles?.includes('super_admin')) {
            if (!location.pathname.startsWith('/admin')) {
                return <Navigate to="/admin" replace />
            } else {
                return children
            }
        } else if (roles?.includes('caregiver')) {
            if (location.pathname !== '/welcome') {
                return <Navigate to="/welcome" replace />
            } else {
                return children
            }
        } else if (routePermissions && routePermissions.length > 0 && routePermissions.some(role => permissions?.includes(role))) {
            return children
        } else {
            if (!messageBox) {
                setMessageBox({
                    status: 'error',
                    title: 'Unauthorized',
                    description: "Authorization failed! You don't have privilege to access this resource!",
                })
            }
            return <Navigate to="/" replace />
        }
    } else {
        return <Navigate to="/login" replace />
    }
}
